import React from 'react'

const NumberFormat = ({ value, decimals = 0 }) => (
    <span>
        {Number(Number(value || 0).toFixed(decimals)).toLocaleString('en')}
    </span>
)

export default NumberFormat
